import * as Yup from "yup";

export const login = Yup.object().shape({
  email: Yup.string().email().required("An email address is required"),
  password: Yup.string().required("A password is required")
});
